export default __webpack_public_path__ + "static/media/faqicon7.bfaca9ff.svg";